import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { ProgressBarSuspenseFallback } from '@vivaldis/web-ui'
import { lazyOrReloadPage } from '../../../../utils/lazyOrReloadPage'

const AddDimonaAttestationRecipient = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "AddDimonaAttestationRecipient" */ './screens/AddDimonaAttestationRecipient'
    )
)
const EditDimonaAttestationRecipient = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "EditDimonaAttestationRecipient" */ './screens/EditDimonaAttestationRecipient'
    )
)
const DimonaAttestationList = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "DimonaAttestationList" */ './screens/DimonaAttestationList'
    )
)

export const DimonaAttestationRoutes = () => {
  return (
    <Suspense fallback={ProgressBarSuspenseFallback}>
      <Routes>
        <Route path="/" element={<DimonaAttestationList />} />
        <Route
          path="add-recipient"
          element={<AddDimonaAttestationRecipient />}
        />
        <Route
          path="edit-recipient/:contactIndex"
          element={<EditDimonaAttestationRecipient />}
        />
      </Routes>
    </Suspense>
  )
}
